import React from 'react';
import PropTypes from 'prop-types';
import classes from './RenderSectionImages.module.scss';

const RenderSectionImages = (props) => {
    const { data } = props;

    if (data?.length === 0) return null;

    return (
        <div className={classes.RenderSectionImages}>
            {data?.map((imgUrl, index) => {
                return (
                    <img key={`${imgUrl}-${index}`} 
                        src={imgUrl} 
                        className={classes.SectionImage}
                        alt="" 
                    />
                )
            })}
        </div>
    )
}

RenderSectionImages.propTypes = {}

export default RenderSectionImages;